import { render, staticRenderFns } from "./NotArrangeMail.vue?vue&type=template&id=3fd52886&scoped=true"
import script from "./NotArrangeMail.vue?vue&type=script&lang=js"
export * from "./NotArrangeMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd52886",
  null
  
)

export default component.exports